import { render, staticRenderFns } from "./CollapsibleList.vue?vue&type=template&id=044ca8b2&lang=pug"
import script from "./CollapsibleList.vue?vue&type=script&lang=js"
export * from "./CollapsibleList.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleList.vue?vue&type=style&index=0&id=044ca8b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports